// eslint-disable-next-line strict
module.exports = null;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/helpers/null.js
// module id = 74
// module chunks = 0